import { withInstall } from '@bigin/utils'

import Empty from './src/empty.vue'

export const BEmpty = withInstall(Empty)
export default BEmpty

export * from './src/empty'
